import { render, staticRenderFns } from "./show2.vue?vue&type=template&id=0135f3a3&"
import script from "./show2.vue?vue&type=script&lang=js&"
export * from "./show2.vue?vue&type=script&lang=js&"
import style0 from "./show2.vue?vue&type=style&index=0&id=0135f3a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports